/*
 * -----------------------------------------------------------------------
 *  <copyright file="admin-organisation-plugin.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { useQuery } from '@apollo/client/react';
import React from 'react';
import { useAuthorization } from 'hooks';
import { GET_ORGANISATION } from 'queries/uam';
import AdminPlugin from 'views/components/admin/admin-plugin';
import Loading from 'views/components/core/loading';
import Error from 'views/components/error/error';

const AdminOrganisationPlugin = () => {
    const user = useAuthorization();
    const { loading, error, data } = useQuery(GET_ORGANISATION, { variables: { id: user.organisationId } });

    if (loading) return <Loading />;

    if (error) return <Error error={error} />;

    return <AdminPlugin organisation={data.organisation} />;
};

export default AdminOrganisationPlugin;
